import { render, staticRenderFns } from "./ReportsCardComponent.vue?vue&type=template&id=193c257c&scoped=true"
import script from "./ReportsCardComponent.vue?vue&type=script&lang=js"
export * from "./ReportsCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportsCardComponent.vue?vue&type=style&index=0&id=193c257c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c257c",
  null
  
)

export default component.exports